import { render, staticRenderFns } from "./LoanableForm.vue?vue&type=template&id=32e3614f"
import script from "./LoanableForm.vue?vue&type=script&lang=js"
export * from "./LoanableForm.vue?vue&type=script&lang=js"
import style0 from "./LoanableForm.vue?vue&type=style&index=0&id=32e3614f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports